
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { NewsService, ReporterService } from '@/services/index'
import Editor from '@/components/editor/index.vue'
import { parseTime, isValidURL } from '@/common/utils'

@Component({
    components: {
        Editor
    }
})
export default class extends Vue {
    private newsRules = {
        title: [
            { required: true, message: '请输入新闻标题', trigger: 'blur' }
        ],
        content: [
            { required: true, min: 300, validator: this.contentValidator }
            // '请输入新闻内容'
        ],
        published_at: [
            { required: true, message: '请上传记者头像', trigger: 'blur' }
        ],
        origin_url: [
            { required: true, validator: this.urlValidator, trigger: 'blur' }
        ]
    }
    private reporterId: number = 0
    private reporter = {}
    private newsForm: any = {
        title: '',
        content: '',
        published_at: '',
        origin_url: '',
        meta_datas: []
    }
    private loading: boolean = true 
    private isSubmitting: boolean = false

    private mounted() {
        this.reporterId = parseInt(this.$route.params.id)
        this.newsForm.rid = this.reporterId
        this.getReporter()
        this.getMetaData()
    }

    private async getReporter() {
        const result = await ReporterService.getDetail({ id: this.reporterId })
        if (result.status === 200) {
            this.reporter = result.data
        }
        this.loading = false
    }

    private async getMetaData() {
        const result = await NewsService.getPlatforms({})
        if (result.status === 200) {
            this.newsForm.meta_datas = result.data
        }
    }

    private async addNews() {
        const result = await NewsService.addNews(this.newsForm)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '文章更新成功' })
            this.$router.push({ path: `/reporter/${this.reporterId}?tab=news` })
        }
    }

    private onContentChange(content: string) {
        this.newsForm.content = content
    }

    private onCancel() {
        this.$router.push({ path: `/reporter/${this.reporterId}?tab=news` })
    }

    private async onSubmit() {
        (this.$refs.newsForm as ElForm).validate(async (valid: boolean) => {
            if (valid) {
                this.isSubmitting = true
                this.newsForm.meta_datas.map((meta: any) => {
                    meta.comment_count = parseInt(meta.comment_count)
                    meta.interact_count = parseInt(meta.interact_count)
                    meta.like_count = parseInt(meta.like_count)
                    meta.read_count = parseInt(meta.read_count)
                    meta.share_count = parseInt(meta.share_count)
                    return meta
                })
                this.newsForm.published_at = parseTime(this.newsForm.published_at)
                await this.addNews()
                this.isSubmitting = false
            }
        })
    }

    private urlValidator(rule: any, value: string, callback: Function) {
        // 检验网址
        let message = '请输入正确的链接地址'
        if (!value) return callback(new Error(message))
        if (!isValidURL(value)) {
            return callback(new Error(message))
        }
        callback()
    }

    private contentValidator(rule: any, value: string, callback: Function) {
        const len = value.length
        if (!len) {
            return callback(new Error('请输入新闻内容'))
        }
        callback()
    }
}
